const config = require('./src/lib/i18n/i18n.config');
/** @type {import('next-i18next').UserConfig} */
module.exports = {
  i18n: {
    defaultLocale: config.defaultLocale,
    locales: config.locales,
  },
  debug: false,
  nsSeparator: '.',
  ns: config.ns,
  interpolation: {
    prefix: '{',
    suffix: '}',
  },
};